import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

const CustomPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{orange.50}',
            100: '{orange.100}',
            200: '{orange.200}',
            300: '{orange.300}',
            400: '{orange.400}',
            500: '{orange.500}',
            600: '{orange.600}',
            700: '{orange.700}',
            800: '{orange.800}',
            900: '{orange.900}',
            950: '{orange.950}'
        }
    },
    components: {
        inputtext: {
            root: {
                background: '#f3f3f5 !important',
                shadow: 'none !important',
                borderColor: 'var(--p-gray-300) !important',
                focusBorderColor: 'var(--p-gray-300) !important',
                focusRing: {
                    width: '3px !important',
                    style: 'solid !important',
                    color: 'oklch(.708 0 0) !important',
                    offset: '0 !important',
                    shadow: 'none !important',
                },
            }
        },
        select: {
            root: {
                background: '#f3f3f5 !important',
            }
        },
        multiselect: {
            root: {
                background: '#f3f3f5 !important',
            }
        },
        button: {
            root: {
                borderRadius: '0.625rem !important',
                primary: {
                    background: 'linear-gradient(to right, var(--p-amber-500), var(--p-primary-500)) !important',
                    activeBackground: 'linear-gradient(to right, var(--p-amber-600), var(--p-primary-600)) !important',
                    hoverBackground: 'linear-gradient(to right, var(--p-amber-600), var(--p-primary-600)) !important',
                    borderColor: 'transparent !important',
                    activeBorderColor: 'transparent !important',
                    hoverBorderColor: 'transparent !important',
                },
                success: {
                    background: 'linear-gradient(to right, var(--p-green-500), var(--p-emerald-500)) !important'
                }
            },
        },
        tag: {
            root: {
                fontSize: '0.75rem !important',
                fontWeight: '500 !important'
            }
        },
        slider: {
            track: {
                size: '1rem !important',
                borderRadius: '0.8rem !important',
            },
            handle: {
                height: '0.8rem !important',
                width: '0.8rem !important',
                borderRadius: '0.8rem !important',
                background: 'var(--p-gray-900) !important',
                hoverBackground: 'var(--p-gray-900) !important',
                content: {
                    height: '0.8rem !important',
                    width: '0.8rem !important'
                }
            },
            range: {
                background: '#000 !important',
            },
        },
        toggleswitch: {
            root: {
                checkedBackground: 'var(--p-primary-500) !important',
                checkedHoverBackground: 'var(--p-primary-600) !important',
                disabledBackground: 'var(--p-gray-200) !important',
            },
            handle: {
                disabledBackground: 'var(--p-gray-400) !important',
            }
        }
    }
})

export default CustomPreset
